import { WatchListSchema } from '@/jsonapi/WatchList'

export interface WatchListState {
  watchLists: WatchListSchema[]
}

export enum WatchStatusTypes {
  EMPTY = '',
  MANUAL = 'manual',
  UNWATCH = 'unwatch',
  AUTO = 'auto',
}
